import React, { useState, useMemo, useEffect } from "react";
import ConfirmationPopup from "../../../../common/components/confirmation-popup/confirmation-popup";
import { AlertComponent } from "../../../../common/components";
import { useSetLoading } from "../../../../common/hooks/appearance";
import { MassDeleteProps } from "../action-types";
import WarningIcon from "@mui/icons-material/Warning";
import { Typography, Box } from "@mui/material";
import { massDeleteCustomers } from "../../../../api/customer";
import { getCampaignDetails } from "../../../../api/campaign";

const MassDeleteOfCustomers: React.FC<MassDeleteProps> = ({
  customerIds,
  setSelectedCustomersMap,
  isOpen,
  setMenuItems,
  selectedActions,
  fetchCustomers,
  handleMassActionMenuClose,
}) => {
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false); // ✅ Loading state
  const [campaignLeads, setCampaignLeads] = useState<
    { campaignId: number; leads: any[] }[]
  >([]);

  // const fetchLeadsForCampaigns = async (customerIds: number[]) => {
  //     setLoading(true);
  //     try {
  //       const campaignLeadData = await Promise.all(
  //         customerIds.map(async (id) => {
  //           const response = await getCampaignDetails(id);
  //           const leads = response?.data?.data?.CampaignLeadAssociation|| [];
  //           return { campaignId: id, leads: leads }
  //         })
  //       );

  //       setLoading(false);
  //       return campaignLeadData; // This is your final array
  //     } catch (error: any) {
  //       setLoading(false);
  //       setAlertMessage(
  //         error?.response?.data?.message ||
  //         "An error occurred while fetching campaign leads."
  //       );
  //       setAlertType("error");
  //       setAlertOpen(true);
  //       return []; // In case of error, return empty
  //     }
  // };

  // useEffect(() => {
  //   if (isOpen && customerIds?.length > 0) {
  //     const fetchData = async () => {
  //       const result = await fetchLeadsForCampaigns(customerIds);
  //       setCampaignLeads(result);
  //     };

  //     fetchData();
  //   }
  // }, [isOpen, customerIds]);

  const handleClose = () => {
    setMenuItems((prevItems) =>
      prevItems.map((item) =>
        item.value === selectedActions
          ? { ...item, isOpen: !item.isOpen }
          : item
      )
    );
    handleMassActionMenuClose();
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await massDeleteCustomers({
        customerIds: customerIds,
      });
      if (response?.status === 204) {
        setAlertMessage(
          `${customerIds?.length === 1 ? "Customer" : "Customer(s)"} archived successfully.`
        );
        setAlertType("success");
        setSelectedCustomersMap({});
        fetchCustomers();
      }
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead."
      );
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setAlertOpen(true);
      handleClose();
    }
  };

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);
  return (
    <>
      {/* {loading && <Loader />}   */}

      <ConfirmationPopup
        open={isOpen}
        title={
          customerIds?.length === 1 ? "Archive Customer" : "Archive Customers"
        }
        note={
          <Box display="flex" alignItems="center" gap={1}>
            <WarningIcon color="warning" />
            <Typography variant="body2">
              {
                <>
                  Are you sure you want to archive{" "}
                  <strong>
                    the selected customer{customerIds?.length > 1 ? "s" : ""}
                  </strong>
                  ? This action cannot be undone.
                </>
              }
            </Typography>
          </Box>
        }
        buttonText="Archive"
        onCancel={handleClose}
        onOkay={handleDelete}
      />

      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default MassDeleteOfCustomers;
